import * as React from "react";

type Props = {
  onEscape?: () => void;
  className?:string;
};

export class EscapeListener extends React.Component<Props> {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    // Normalize across browsers
    if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
      if (this.props.onEscape) {
        this.props.onEscape();
      }
    }
  };

  render() {
    return <div className={this.props.className}>{this.props.children}</div>;
  }
}